import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { indexOf, without, concat } from 'lodash';
import Fa from 'react-fontawesome';
import masterField from '../../../../../components/search-form/master-field';

const activityTypesOptions = [
  { value: 'Email', label: 'Email' },
  { value: 'Call', label: 'Call' },
  { value: 'Event', label: 'Event' },
  { value: 'Task', label: 'Task' },
];

class ActivityTypeField extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.toggleRole = this.toggleRole.bind(this);
  }

  toggleRole(option) {
    const { value } = this.props;
    const exists = indexOf(value, option) >= 0;
    const newOptions = exists ? without(value, option) : concat(value, option);
    // https://github.com/lumen-software/TruSales/issues/1701
    // if (newOptions.length === 0) {
      // newOptions = map(allOptions, 'value');
    // }
    this.props.onChange(newOptions);
  }

  render() {
    const { value, disabled } = this.props;
    return (
      <div>
        {activityTypesOptions.map((option) => {
          const active = indexOf(value, option.value) >= 0;
          const lbl = (option.value && option.label !== option.value) ? (<span>{option.label} (<code>{option.value}</code>)</span>) : option.label;
          const innerLabel = (
            <span><Fa name={active ? 'check-square' : 'square-o'} className={active ? 'text-success' : ''} /> {lbl}</span>
          );
          const labelComp = option.value === null ? (<em>{innerLabel}</em>) : innerLabel;
          return (
            <div key={option.value}>
              <div
                style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                key={option.value}
                onClick={() => {
                  if (!disabled) {
                    this.toggleRole(option.value);
                  }
                }}
              >
                {labelComp}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

ActivityTypeField.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  onChange: PropTypes.func,
};
ActivityTypeField.defaultProps = {
  value: [],
  disabled: false,
  submitting: false,
};
export default masterField(ActivityTypeField);
